import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = signed out, object = signed in
  const [user, setUser] = useState(null);
  // true after an explicit sign-out, so we show the login page instead of auto-starting a guest
  const [signedOut, setSignedOut] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setSignedOut(true);
    setUser(false);
  }, []);

  const startGuest = useCallback(async () => {
    const { data } = await api.post("/auth/guest");
    setSignedOut(false);
    setUser(data);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, checkAuth, logout, startGuest, signedOut }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
